import type { IntegrationListItemType } from "@sellar-io/api-v2/types";

export const getIntegrationName = (integration: IntegrationListItemType) => {
  switch (integration.type) {
    case "xero": {
      return "Xero";
    }
    case "quickbooks": {
      return "Quickbooks";
    }
    case "freeagent": {
      return "FreeAgent";
    }
    default: {
      return null;
    }
  }
};

export const getIntegrationPlaceholder = (
  integration: IntegrationListItemType,
) => {
  return integration.type === "quickbooks" ? "Customer ID" : "Contact ID";
};
